<template>
  <main-layout
    controlsBg="light"
    :hasControlsBar="false"
    :breadcrumb="getBreadcrumb">
    <div class="container">
      <grid-row column-align="center">
        <grid-col col-size="4">
          <h1 class="header margin-top-xl">
            <chevron
              @click="$router.push({name: 'GroupList'})"/>
            {{ isEdition() ? $t('group.edit') : $t('group.new') }}
          </h1>
          <alert
            v-if="alertVisible"
            :message="alertMessage"
            :type="alertType">
          </alert>
        </grid-col>
      </grid-row>
      <form
        v-on:submit.prevent
        v-on:keypress.enter.prevent="onSave">
        <grid-row column-align="center">
          <grid-col col-size="4">
            <div class="variable-input-field variable-input-field-name">
              <label-input
                ref="nameInput"
                form-size="m"
                :label="$t('group.name')"
                v-model="name"
                :type="'text'"
                :error="nameError"
                :errorMessage="displayNameErrorMessage">
              </label-input>
            </div>
          </grid-col>
        </grid-row>
        <grid-row column-align="center">
          <grid-col col-size="4">
            <div class="variable-input-field submit-buttons align-right">
              <br>
              <btn-pill
                :btnText="$t('commons.cancel')"
                v-on:click="onCancel"
                btn-size="m"
                btn-type="secondary">
              </btn-pill>
              <btn-pill
                :btnText="$t('commons.save')"
                v-on:click="onSave"
                btn-size="m">
              </btn-pill>
            </div>
          </grid-col>
        </grid-row>
      </form>
    </div>
  </main-layout>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import MainLayout from '../MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import LabelInput from '@/components/shared/forms/LabelInput';
import LabelSelect from '@/components/shared/forms/LabelSelect';
import Radio from '@/components/shared/forms/Radio';
import ToggleSwitch from '@/components/shared/forms/ToggleSwitch';
import BtnPill from '@/components/shared/buttons/BtnPill';
import Checkbox from '@/components/shared/forms/Checkbox';
import Alert from '@/components/shared/alert/Alert';
import Chevron from '@/components/shared/Chevron';

export default {
  components: {
    MainLayout,
    GridRow,
    GridCol,
    LabelInput,
    LabelSelect,
    Radio,
    ToggleSwitch,
    BtnPill,
    Checkbox,
    Alert,
    Chevron
  },
  data () {
    return {
      group: {},
      name: '',
      /* Form field errors */
      nameError: false,
      /* UI controls */
      alertVisible: false,
      alertMessage: '',
      alertType: '' // error, warning, success
    };
  },
  computed: {
    ...mapGetters([
      'getRootGroup'
    ]),
    getBreadcrumb () {
      return [
        {
          link: '/settings',
          name: this.$t('menu.settings')
        },
        {
          link: '/group/list',
          name: this.$t('group.title')
        },
        {
          link: '/group',
          name: this.isEdition() ? this.$t('group.edit') : this.$t('group.new'),
          disabled: true
        }
      ];
    },
    displayNameErrorMessage () {
      let errorMessage = this.$t('commons.mandatoryFieldMessage');
      if (this.name.length > 0) {
        errorMessage = this.$t('group.groupAlreadyExists');
      }
      return errorMessage;
    }
  },
  created () {
    this.group = this.$route.params;
    if (this.isEdition()) {
      this.name = this.group.name;
    }
  },
  mounted () {
    this.$refs.nameInput.focus();
  },
  methods: {
    ...mapActions([
      'updateGroup',
      'createGroup',
      'retrieveGroups'
    ]),
    isEdition () {
      return this.group.id !== undefined;
    },
    onSave () {
      this.nameError = false;
      if (isValidForm(this)) {
        this.group.name = this.name;

        if (this.isEdition()) {
          updateGroup(this, this.group);
        } else {
          this.group.parentId = this.getRootGroup.id;
          createGroup(this, this.group);
        }
      } else {
        this.nameError = true;
      }
    },
    onCancel () {
      this.$router.push('GroupList');
    }
  }
};

const isValidForm = context => {
  return context.name && context.name.length > 0;
};

const createGroup = (context, group) => {
  context.createGroup({context: context, group}).then(() => {
    const msg = context.$t('group.successCreation', {name: group.name});
    context.$router.replace({ name: 'GroupList', params: {alert: msg} });
  }).catch((error) => {
    if (error.status === 409) {
      context.nameError = true;
    } else {
      showAlert(context, context.$t('group.errorCreation'), 'error');
    }
  });
};

const updateGroup = (context, group) => {
  const msg = context.$t('group.successUpdate', {name: group.name});
  context.updateGroup({context: context, group}).then(() => {
    context.$router.replace({ name: 'GroupList', params: {alert: msg} });
  }).catch((error) => {
    if (error.status === 409) {
      context.nameError = true;
    } else {
      showAlert(context, context.$t('group.errorUpdate', {name: group.name}), 'error');
    }
  });
};

const showAlert = (context, message, type) => {
  context.alertVisible = true;
  context.alertMessage = message;
  context.alertType = type;
  context.showAlert = true;
  setTimeout(() => {
    context.alertVisible = false;
  }, 2000);
};

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/groups/Group.vue